<menu *ngIf="!isLogin" [app_name]="title">
  <router-outlet></router-outlet>
</menu>
<div *ngIf="isLogin">
  <router-outlet></router-outlet>
</div>
